import {
    getCategory,
    getCategoryB2C,
    getDifficulty,
    getGrade,
    getBusiness
} from "./../api.js";

export const state = {
    difficulty: [],
    category: [],
    categoryb2c: [],
    grade: [],
    business: [],
}

export const getters = {
    difficulty: (state) => state.difficulty,
    category: (state) => state.category,
    categoryb2c: (state) => state.categoryb2c,
    grade: (state) => state.grade,
    business: (state) => state.business,
}

export const mutations = {
    setDifficulty(state, data) {
        state.difficulty = data.difficulty.data;
    },
    setCategory(state, data) {
        state.category = data.category.data;
    },
    setCategoryB2C(state, data) {
        state.categoryb2c = data.categoryb2c.data;
    },
    setGrade(state, data) {
        state.grade = data.grade.data;
    },
    setBusiness(state, data) {
        state.business = data.business.data;
    },
}

export const actions = {
    async getCategory({ commit }) {
        const category = await getCategory();
        commit("setCategory", { category: category });
    },
    async getCategoryB2C({ commit }) {
        const categoryb2c = await getCategoryB2C();
        commit("setCategoryB2C", { categoryb2c: categoryb2c });
    },
    async getDifficulty({ commit }) {
        const difficulty = await getDifficulty();
        commit("setDifficulty", { difficulty: difficulty });
    },
    async getGrade({ commit }) {
        const grade = await getGrade();
        commit("setGrade", { grade: grade });
    },

    async getBusiness({ commit }) {
        const business = await getBusiness();
        commit("setBusiness", { business: business });
    },

}
